import { render, staticRenderFns } from "./UploadVideoWizard.vue?vue&type=template&id=1acdb20e&scoped=true"
import script from "./UploadVideoWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadVideoWizard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UploadVideoWizard.vue?vue&type=style&index=0&id=1acdb20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acdb20e",
  null
  
)

export default component.exports